import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  contentChildren,
  ElementRef,
  EventEmitter,
  HostBinding,
  input,
  Output,
  TemplateRef,
  viewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Dropdown, DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { OspTemplateDirective } from '../../../directives/osp-template.directive';
import { CoreControlDirective } from '../../../utils/core-control.directive';
import { DropdownItemComponent } from './components/dropdown-item/dropdown-item.component';
import { DropdownVariant } from './contract/dropdown-variant.contract';
import { DropdownCustomTemplateTypes } from './enums/dropdown-custom-templates.enum';

@Component({
  selector: 'osp-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss',
  standalone: true,
  imports: [DropdownModule, ReactiveFormsModule, NgTemplateOutlet, DropdownItemComponent],
  encapsulation: ViewEncapsulation.None,
  providers: CoreControlDirective.coreControlProvider(DropdownComponent),
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownComponent extends CoreControlDirective {
  @HostBinding('class.osp-dropdown') protected hostCssClassEnabled = true;

  dropdownCustomContent = contentChildren(OspTemplateDirective);
  readonly dropdownCustomTemplateTypes = DropdownCustomTemplateTypes;

  options = input<unknown[]>([]);
  filter = input(false);
  filterBy = input<string>();
  showClear = input(false);
  placeholder = input<string>();
  optionLabel = input<string>('label');
  optionValue = input<string>('value');
  loading = input(false);
  variant = input<DropdownVariant>('outlined');
  cssClass = input('');
  panelStyleClass = input('default-dropdown-panel');
  appendTo = input<HTMLElement | ElementRef | TemplateRef<unknown> | string | unknown>('body');
  group = input(false);
  readonly = input(false);
  dataKey = input<string>();
  handleChangeResetControl = input(false);
  $virtualScroll = input(false, { alias: 'virtualScroll' });
  $virtualScrollItemSize = input(30, { alias: 'virtualScrollItemSize' }); // Change default item size if default styles are changed

  @Output() onChangeEvent = new EventEmitter<DropdownChangeEvent>();

  private dropdownComponent = viewChild<Dropdown>('dropdown');

  closePanel(): void {
    this.dropdownComponent()?.hide(true);
  }

  openPanel(): void {
    this.dropdownComponent()?.show(true);
  }

  onChange($event: DropdownChangeEvent): void {
    const selectedItem = $event?.value;

    if (selectedItem?.disabled) {
      this.closePanel();
      return;
    }
    this.onChangeEvent.emit($event);

    if (this.handleChangeResetControl()) {
      this.control().reset();
    }
  }
}
